
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Link } from 'react-router-dom';

const classNames = mergeStyleSets({
    HomePage: {
        padding: 16
    },
    ArticleListItem: {
        paddingTop: 8,
        paddingBottom: 8,
        fontSize: '18px',
        fontWeight: 'bold',
        'a': {
            color: '#7f5326',
            textDecoration: 'none'
        },
        'a:hover': {
            color: '#7f5326',
            textDecoration: 'underline'
        },
        'a:visited': {
            color: '#7f5326'
        }
    },
    abstract: {
        paddingTop: 8,
        fontSize: '14px',
        fontWeight: 'normal',
        textAlign: 'justify'
    }
});

const ArticleListItem = ({article}) => {
    return (
        <Stack className={classNames.ArticleListItem}>
            <Link to={`/article/${article.name}`}>{article.title}</Link>
            <p className={classNames.abstract}>{article.abstract}</p>
        </Stack>
    );
}

const ArticleList = ({articles}) => {
    return (
        <Stack>
            {(articles || []).map(item => {
                return (
                    <ArticleListItem
                        key={item.id}
                        article={item}
                    />
                )
            })}
        </Stack>
    );
}

export default ArticleList;
